import React from 'react';
import { TrackingModuleLayout } from '../layouts/TrackingModuleLayout';
import { HomeContent } from '../components/HomeContent/HomeContent';

/** @type {React.FC<{}>} */
const PageNotFound = () => {
    return (
        <TrackingModuleLayout hideSearchBar={true}>
            <HomeContent message='Sorry! That page was not found.' />
        </TrackingModuleLayout>
    );
};

export default PageNotFound;
